import { render, staticRenderFns } from "./looksurvey1.vue?vue&type=template&id=a9275472&scoped=true&"
import script from "./looksurvey1.vue?vue&type=script&lang=js&"
export * from "./looksurvey1.vue?vue&type=script&lang=js&"
import style0 from "./looksurvey1.vue?vue&type=style&index=0&id=a9275472&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9275472",
  null
  
)

export default component.exports